
import buttonList from './src/button-list.vue'
import buttonItem from './src/button-item.vue'

// 为组件提供 install 安装方法，供按需引入
buttonList.install = function (Vue) {
  Vue.component(buttonList.name, buttonList)
}
buttonItem.install = function (Vue) {
  Vue.component(buttonItem.name, buttonItem)
}

// 默认导出组件
export default { buttonList, buttonItem }
